var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",attrs:{"id":"people-detail"}},[_c('h1',[_vm._v(_vm._s(_vm.pageTitle))]),_c('div',{staticClass:"content-body two-columns form-wrapper"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"block"},[_c('PeopleForm')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }